import { render } from "./accountOpeningProgressCY.vue?vue&type=template&id=fbc51578&scoped=true"
import script from "./accountOpeningProgressCY.vue?vue&type=script&lang=js"
export * from "./accountOpeningProgressCY.vue?vue&type=script&lang=js"

import "./accountOpeningProgressCY.vue?vue&type=style&index=0&id=fbc51578&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fbc51578"

export default script